window.MaissonDesign.register(({on, cleanup}) => {
  const panel = document.querySelector('.mm-uploadkit-panel');
  if (!panel) return;
  const mount = panel.querySelector('.uploadkit');
  const source = panel.querySelector('.mm-uploadkit-layout-source');
  const status = panel.querySelector('.mm-uploadkit-status');
  const slots = new Map([...source.querySelectorAll('[data-uploadkit-slot]')].map(slot => [slot.dataset.uploadkitSlot.toLowerCase(), slot]));
  let timedOut = false;
  const owned = (field, role, create) => {
    let node = [...field.children].find(child => child.dataset.mmUploadkitUi === role);
    if (!node) {
      node = create();
      node.dataset.mmUploadkitUi = role;
      field.prepend(node);
    }
    return node;
  };
  const heading = (field, type) => owned(field, 'heading', () => {
    const node = document.createElement('div');
    node.className = 'mm-uploadkit-step';
    node.setAttribute('role', 'heading');
    node.setAttribute('aria-level', '3');
    node.append(...[...source.querySelector(`.${type}-fields legend`).childNodes].map(child => child.cloneNode(true)));
    return node;
  });
  const refresh = () => {
    const found = new Set();
    let firstExtra;
    for (const field of mount.querySelectorAll('.uploadkit-uploader')) {
      const input = field.querySelector('input[name^="properties["], textarea[name^="properties["]');
      const button = field.querySelector('.uploadkit-button');
      const isUpload = field.classList.contains('uploadkit-upload-field');
      let key = input?.name.match(/^properties\[(.*)\]$/)?.[1].trim().toLowerCase();
      if (key === 'special message') key = 'message';
      if (isUpload) {
        if (!button) continue;
        const name = button.dataset.uploaderName || field.querySelector('.uploadkit-label')?.textContent || '';
        key = /cover/i.test(name) ? 'cover' : /photos|pictures|images|trip/i.test(name) ? 'photos' : null;
      }
      const slot = slots.get(key);
      if (!slot) continue;
      found.add(key);
      const kind = ['destination','title','pet name'].includes(key) ? 'title' : key === 'order notes' ? 'requests' : key;
      field.classList.add('mm-uploadkit-placed');
      field.dataset.mmKind = kind;
      field.dataset.mmLabel = slot.querySelector('.mm-field-label').textContent.trim();
      const label = owned(field, 'label', () => {
        const node = slot.querySelector('label').cloneNode(true);
        node.id = `mm-label-${field.dataset.uploaderId || input?.id || key.replaceAll(' ', '-')}`;
        node.classList.add('mm-uploadkit-field-label');
        return node;
      });
      if (input && !isUpload) {
        label.htmlFor = input.id;
        input.setAttribute('aria-labelledby', label.id);
        input.placeholder = slot.dataset.placeholder;
        input.dir = 'auto';
        if (input.tagName === 'TEXTAREA') input.rows = key === 'message' ? 3 : slots.has('title') ? 5 : 2;
        const optional = label.querySelector('.mm-field-optional');
        if (optional) optional.hidden = input.required;
      }
      if (button) {
        button.setAttribute('aria-labelledby', label.id);
        const text = button.querySelector('span');
        if (text && !input?.value && text.textContent !== slot.dataset.buttonLabel) text.textContent = slot.dataset.buttonLabel;
        owned(field, 'helper', () => {
          const node = document.createElement('p');
          node.className = 'mm-uploadkit-helper';
          node.textContent = slot.dataset.placeholder;
          return node;
        });
      }
      if (kind === 'title') heading(field, 'story');
      if (kind === 'photos') heading(field, 'upload');
      if (kind === 'message') heading(field, 'message');
      if (kind === 'requests') firstExtra ||= field;
    }
    for (const field of mount.querySelectorAll('.mm-uploadkit-extra-first')) {
      if (field !== firstExtra) {
        field.classList.remove('mm-uploadkit-extra-first');
        field.querySelector('[data-mm-uploadkit-ui="toggle"]')?.remove();
      }
    }
    if (firstExtra) {
      firstExtra.classList.add('mm-uploadkit-extra-first');
      const toggle = owned(firstExtra, 'toggle', () => {
        const node = document.createElement('button');
        node.type = 'button';
        node.className = 'mm-uploadkit-extras-toggle';
        node.append(...[...source.querySelector('.extra-options summary').childNodes].map(child => child.cloneNode(true)));
        return node;
      });
      toggle.setAttribute('aria-expanded', String(panel.classList.contains('mm-extras-open')));
    }
    const browserNotices = [...mount.querySelectorAll('.uploadkit-ios-fb-message, .uploadkit-android-fb-message')];
    const visibleBrowserNotice = browserNotices.find(node => node.textContent.trim() && node.closest('[data-mm-kind="cover"]'))
      || browserNotices.find(node => node.textContent.trim() && node.closest('[data-mm-kind="photos"]'))
      || browserNotices.find(node => node.textContent.trim());
    for (const notice of browserNotices) {
      notice.classList.toggle('mm-uploadkit-browser-help-duplicate', notice !== visibleBrowserNotice);
    }
    const fallbackSource = source.querySelector('[data-uploadkit-fallback]');
    if (fallbackSource) {
      fallbackSource.disabled = true;
      let fallback = panel.querySelector('[data-mm-pet-fallback]');
      if (!fallback) {
        fallback = document.createElement('div');
        fallback.dataset.mmPetFallback = '';
        fallback.dataset.uploadkitSlot = 'Pet name';
        fallback.className = 'mm-uploadkit-native-title';
        heading(fallback, 'story');
        const slot = slots.get('pet name');
        const label = slot.querySelector('label').cloneNode(true);
        label.id += '-native';
        label.htmlFor = 'mm-native-pet-name';
        const input = fallbackSource.cloneNode(true);
        input.id = 'mm-native-pet-name';
        fallback.append(label, input);
        mount.before(fallback);
      }
      fallback.hidden = found.has('pet name');
      fallback.querySelector('input').disabled = found.has('pet name');
    }
    status.hidden = found.has('photos') && found.has('cover');
    const message = timedOut ? status.dataset.unavailable : status.dataset.loading;
    if (status.textContent !== message) status.textContent = message;
  };
  const observer = new MutationObserver(refresh);
  observer.observe(mount, {childList:true, subtree:true});
  const form = panel.closest('form');
  on(panel, 'click', event => {
    if (!event.target.closest('.mm-uploadkit-extras-toggle')) return;
    panel.classList.toggle('mm-extras-open');
    refresh();
  });
  on(form, 'invalid', event => {
    if (event.target.closest('[data-mm-kind="requests"]')) {
      panel.classList.add('mm-extras-open');
      refresh();
    }
  }, {capture:true});
  const reviewNote = document.querySelector('.review-notice');
  if (reviewNote) reviewNote.textContent = panel.dataset.reviewNote;
  const timeout = setTimeout(() => { timedOut = true; refresh(); }, 20000);
  const src = 'https://assets.getuploadkit.com/assets/uploadkit-app.js';
  if (![...document.scripts].some(script => /(?:assets\.getuploadkit\.com\/assets\/uploadkit-app|file-uploads-by-uploadkit[^/]*\/assets\/uploadkit-app)/.test(script.src))) {
    const script = document.createElement('script');
    script.src = src;
    script.defer = true;
    script.addEventListener('error', () => { timedOut = true; refresh(); }, {once:true});
    document.head.append(script);
  }
  refresh();
  cleanup(() => { observer.disconnect(); clearTimeout(timeout); });
});
